import React, { Component } from "react"

class ConfirmationBox extends Component {
  state = {
    deleteConfirmInput: "",
  };

  handleDeleteInputChange = (e) => {
    this.setState({ deleteConfirmInput: e.target.value })
  };

  render() {
    return (
      <div className="modal-overlay">
        <div className="modal">
          <h3>{this.props.heading}</h3>
          <p>
            {this.props.text && this.props.text}
            {this.props.markup && this.props.markup}
            Type <b>delete</b> to confirm.
          </p>
          <input
            type="text"
            value={this.state.deleteConfirmInput}
            onChange={this.handleDeleteInputChange}
            placeholder='Type "delete" to confirm'
          />
          <div className="modal-actions">
            <button className="button" onClick={this.props.closeDeleteModal}>Cancel</button>
            <button
              className="button danger"
              disabled={this.state.deleteConfirmInput !== "delete"}
              onClick={this.props.handleBulkDelete}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default ConfirmationBox



// WEBPACK FOOTER //
// client/components/util/ConfirmationBox.js